import React from 'react';
import { useLocation } from 'react-router';

import { ROUTE_PATH } from 'app/lib/routing/constants';

import { PrematchUnionsMenuLayer } from '../../submodules/PrematchMenu/layers/Unions';

export const InnerListForRootMenu = () => {
  const { pathname } = useLocation();
  const isLive = pathname.includes(ROUTE_PATH.LIVE);

  if (isLive) {
    return null;
  }

  return <PrematchUnionsMenuLayer />;
};
